import { Component, OnInit } from '@angular/core';
import { DevExtremeModule } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import moment from 'moment';
import { AppInformationService, AuthService, CdrUnitOfWork } from 'src/app/core/core.module';
import { TimeEntry } from 'src/app/core/model/time-entry';
import { DialogService } from 'src/app/shared/dialog.service';
import { TimeEntryDialogComponent } from '../time-entry-dialog/time-entry-dialog.component';

@Component({
    selector: 'app-time-overview',
    templateUrl: './time-overview.component.html',
    styleUrls: ['./time-overview.component.scss'],
    standalone: true,
    imports: [DevExtremeModule]
})
export class TimeOverviewComponent implements OnInit {
    dayEntries: TimeEntry[];
    weekEntries: TimeEntry[];
    displayDate: string;
    weekFilter = { startDate: new Date(), endDate: new Date() };
    dayFilter = { date: new Date() };

    constructor(
        private uow: CdrUnitOfWork,
        private dialogService: DialogService,
        private appInfo: AppInformationService,
        private auth: AuthService
    ) {}

    async ngOnInit() {
        let weekStart = new Date();
        weekStart.setDate(weekStart.getDate() - weekStart.getDay());
        this.weekFilter.startDate = weekStart;
        this.weekFilter.endDate.setDate(this.weekFilter.startDate.getDate() + 6);
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        if (!!this.dayFilter.date) {
            this.dayEntries = await this.uow.getTimeEntriesByDate(this.dayFilter.date);
            this.displayDate = moment(this.dayFilter.date).format('dddd, MMMM D, YYYY');
        }
        if (!!this.weekFilter.startDate && !!this.weekFilter.endDate) {
            this.weekEntries = await this.uow.getTimeEntriesByDateRange(this.weekFilter.startDate, this.weekFilter.endDate);
        }
        this.appInfo.pleaseWaitHide();
    }

    dayFilterChangeDate(offset?: number) {
        this.dayFilter.date = moment(this.dayFilter.date).add(offset, 'days').toDate();
        this.getData();
    }

    async onDateChanged() {
        await this.getData();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons'
            },
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    }
                }
            },
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    }
                }
            }
        );
    }

    async open(data?: any) {
        let dialogRef = this.dialogService.open(TimeEntryDialogComponent);
        dialogRef.instance.timeEntry = data;
        dialogRef.instance.date = this.dayFilter.date;
        const result = await dialogRef.instance.show();
        if (result.success) {
            this.appInfo.pleaseWaitShow();
            await this.getData();
            this.appInfo.pleaseWaitHide();
        }
        this.dialogService.close(dialogRef);
    }

    async delete(data: any) {
        const success = await confirm(`Are you sure you want to DELETE this time entry?`, this.appInfo.company);
        if (!success) return;
        this.appInfo.pleaseWaitShow();
        data.deleted = new Date();
        data.deletedBy = this.auth.userValue.userName;
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    rowDoubleClick(e) {
        this.open(e.data);
    }

    previousWeek() {
        let startDate = new Date(this.weekFilter.startDate);
        startDate.setDate(startDate.getDate() - startDate.getDay() - 7);
        this.weekFilter.startDate = startDate;
        this.weekFilter.endDate = new Date(this.weekFilter.startDate);
        this.weekFilter.endDate.setDate(this.weekFilter.endDate.getDate() + 6);
        this.getData();
    }

    nextWeek() {
        let startDate = new Date(this.weekFilter.startDate);
        startDate.setDate(startDate.getDate() - startDate.getDay() + 7);
        this.weekFilter.startDate = startDate;
        this.weekFilter.endDate = new Date(this.weekFilter.startDate);
        this.weekFilter.endDate.setDate(this.weekFilter.endDate.getDate() + 6);
        this.getData();
    }
}
